module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/eef2db022a11a91cf48257e10f01ee05.png";